import React from 'react';

import {SupportedLanguage} from '../types';
import {formatDate} from '../utils/dates';

interface FormattedDateProps {
	date: string;
	lang: SupportedLanguage;
}

function FormattedDate({date, lang}: FormattedDateProps) {
	return (
		<time dateTime={date} title={new Date(date).toLocaleString()}>
			{formatDate({date, lang})}
		</time>
	);
}

export default FormattedDate;
